import React from 'react';
import LeftForm from '../../Components/Forms/LeftForm';
import RightTable from '../../Components/Tables/RightTable';
import ToolboxesForm from '../../Components/Forms/LeftFormInputs';

const columns = [
  [
    {
      Header: 'Nom',
      accessor: 'name',
      inputType: 'text',
      required: true,
    },
    {
      Header: 'Coché si disponible',
      accessor: 'available',
      inputType: 'checkbox',
      filterable: false,
      Cell: row => {
        return (
          <div className="bool">
            {row.original[row.column.id] ? 'Oui' : 'Non'}
          </div>
        );
      },
    },
    {
      Header: 'Notes',
      accessor: 'note',
      inputType: 'textarea',
    },
  ],
];

const Toolboxes = () => (
  <React.Fragment>
    <LeftForm title="Créer un nouveau coffre" model="toolboxes">
      <ToolboxesForm model="toolboxes" columns={columns} />
    </LeftForm>
    <RightTable
      title="Liste de coffres"
      model="toolboxes"
      columns={columns[0]}
    />
  </React.Fragment>
);

export default Toolboxes;
